


















































































































































































































































import { Component, Vue, Emit, Prop, PropSync } from "vue-property-decorator";
import Toolbox from "@/components/Toolbox.vue";
import { Layout } from "../interfaces/layout";
import Paginator from "@/components/Paginator.vue";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import ScriptManagerEditForm from "@/components/ScriptManagerEditForm.vue";
import BackgroundSettings from "@/interfaces/studioBackground";

@Component({
    components: {
        Toolbox,
        Paginator,
        ScriptManagerEditForm,
    },
})
export default class ScriptBuilderBar extends Vue {
    @PropSync("pages") public pagesProp!: {
        fullscreenWidgetId: string | null;
        layout: Layout[];
        configurationIds: string[];
        title: string;
    }[];
    @Prop() public pageIndex!: number;

    @Prop() public configurations!: WidgetConfiguration<
        WidgetState,
        WidgetPayload
    >[];

    @Emit() public prev() {
        return;
    }

    @Emit() public next() {
        return;
    }

    @Emit() public load() {
        return;
    }

    @Emit() public save() {
        return;
    }
    @Emit() public leave() {
        return;
    }

    @Emit() public toolboxClick(event: { type: string; static: boolean }) {
        return event;
    }

    @Emit() public toolboxReuse(event: { widgetId: string }) {
        return event;
    }

    @Emit() public paginatorClick(event: { index: number }) {
        return event;
    }
    @Emit() public addPageClick() {
        return;
    }
    @Emit() public removePageClick(event: { index: number }) {
        return event;
    }

    @Emit() public changeBackground(newBackground: BackgroundSettings) {
        return newBackground;
    }

    public toolboxVisible: boolean = false;
    public pagesVisible: boolean = false;
    public editModeActive: boolean = false;
    public navigationVisible: boolean = true;
}
